import React from "react";
import ReactDOM from "react-dom";
import { IoMdExit } from "react-icons/io";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const LogoutModal = ({ isVisible, onCancel, onConfirm }) => {
  const dealershipTheme = useTheme() || "#3b82f6";

  if (!isVisible) return null; // Only render if visible

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-md animate-fade-in">
      <div className="glass-panel w-full max-w-sm p-8 rounded-2xl shadow-2xl flex flex-col items-center text-center animate-scale-in border border-blue-200/50 relative">
        <div 
          className="w-16 h-16 rounded-full flex items-center justify-center mb-6 bg-white shadow-inner border border-blue-200/50" 
          style={{ color: dealershipTheme }}
        >
          <IoMdExit size={32} />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">Sign Out</h3>
        <p className="text-slate-600 mb-8">Are you sure you want to logout from your account?</p>
        
        <div className="flex gap-4 w-full">
          <button 
            className="flex-1 px-4 py-2.5 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 transition-colors border border-blue-200 shadow-md"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="flex-1 px-4 py-2.5 rounded-lg font-medium text-white shadow-lg transition-transform hover:-translate-y-0.5 active:translate-y-0" 
            style={{ background: dealershipTheme }} 
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutModal;
